import { UserInputError } from "./errors-CEDWDXew.js";

//#region src/tools/catalog/support/project-constraints.ts
function projectConstraintError(resourceLabel, projectSlug$1) {
	return new UserInputError(`${resourceLabel} is outside the active project constraint. Expected project "${projectSlug$1}".`);
}
function projectSlug(project) {
	return project?.slug ?? null;
}
function assertProjectRefWithinConstraint({ resourceLabel, scopedProjectSlug, project }) {
	if (!scopedProjectSlug) return;
	if (projectSlug(project) !== scopedProjectSlug) throw projectConstraintError(resourceLabel, scopedProjectSlug);
}
function assertProjectListContainsConstraint({ resourceLabel, scopedProjectSlug, projects }) {
	if (!scopedProjectSlug) return;
	const hasMatchingProject = projects?.some((project) => projectSlug(project) === scopedProjectSlug) ?? false;
	if (!hasMatchingProject) throw projectConstraintError(resourceLabel, scopedProjectSlug);
}
function assertProjectConstraintEvidence({ resourceLabel, scopedProjectSlug, hasEvidence }) {
	if (!scopedProjectSlug || hasEvidence) return;
	throw projectConstraintError(resourceLabel, scopedProjectSlug);
}

//#endregion
export { assertProjectConstraintEvidence, assertProjectListContainsConstraint, assertProjectRefWithinConstraint };
//# sourceMappingURL=project-constraints-DlfcU4mm.js.map